import React from 'react';

import {
  Box,
  Typography
} from '@mui/material';

import {
  heroCaptionDotSx,
  heroCaptionSx,
  heroContentSx,
  heroDescriptionSx,
  heroHeadingAccentSx,
  heroSectionSx,
  heroTitleSx
} from '../../Common/components/Styles/AuthStyles';

const AuthHero = () => {
  return (
    <Box
      component="section"
      sx={heroSectionSx}>
      <Box sx={heroContentSx}>
        <Typography
          component="h1"
          sx={heroTitleSx}>
          Electronic Health Record
        </Typography>

        <Typography sx={heroDescriptionSx}>
          Securely access patient records, manage
          appointments, document clinical encounters,
          and streamline care delivery.
        </Typography>

        <Box sx={heroHeadingAccentSx} />

        <Box sx={heroCaptionSx}>
          <Typography component="span">
            Built for healthcare professionals
          </Typography>

          <Box
            component="span"
            sx={heroCaptionDotSx}
          />

          <Typography component="span">
            Designed for better patient care
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthHero;